import type { ActionMessage } from '../types';
import { invokeAction } from './invoke';

export interface RetryPhotoCollectionProps {
  readonly ids?: string[];
}

export type RetryPhotoCollectionAction = ActionMessage<'retryPhotoCollection', RetryPhotoCollectionProps>;
export const retryPhotoCollection = invokeAction('uniclientAction', 'retryPhotoCollection');
